@if (value(); as chips) {
  <div class="chip-group" role="group">
    <div class="chip-group__list">
      @for (chip of chips; track chip; let i = $index) {
        <span class="chip" [class.chip--invalid]="isInvalid(chip)">
          {{ chip }}
          <button type="button" class="chip__remove" aria-label="Remove" (click)="remove(i)">×</button>
        </span>
      }
    </div>
    <input class="chip-group__field" [value]="draft()" [placeholder]="placeholder()" (input)="onInput($event)" (keydown)="onKeydown($event)" (blur)="commit()" />
  </div>
} @else {
  <span class="chip chip--{{ variant() }} chip--{{ size() }} d-inline-flex align-items-center lh-1 text-nowrap" [class.rounded-pill]="shape() === 'pill'" [class.rounded-2]="shape() === 'rounded'">
    {{ label() }}
    @if (removable()) {
      <button class="chip__remove ms-1 p-0 border-0 bg-transparent" (click)="onRemove($event)" type="button" [attr.aria-label]="'Remove ' + label()">&#x2715;</button>
    }
  </span>
}
